import { all } from 'redux-saga/effects';

import onlineServiceSaga from './onlineService-saga';

export default function* rootSaga() {
  yield all([onlineServiceSaga()]);
}
